import { useState } from "react";
import PageTemplate from "../components/PageTemplate";
import PhotoAlbum from "react-photo-album";
import "react-photo-album/rows.css";
import "react-photo-album/masonry.css";
import "react-photo-album/columns.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Fullscreen, Slideshow, Download } from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Container from "../components/Container";
import Content from "../components/Content";
import WideContent from "../components/WideContent";
import portraits from '../portraitsPhotos.json'
import portraitsThumbnails from '../portraitsThumbnailsPhotos.json'
import { Link } from 'react-router-dom';
import PageFade from "../motions/PageFade";
import { useEffect } from 'react';

function PortraitLoungePhotos() {
    console.log("PortraitLoungePhotos rendered");

    useEffect(() => {
        console.log("PortraitLoungePhotos mounted");

        return () => {
            console.log("PortraitLoungePhotos unmounted");
        };
    }, []);

    const [index, setIndex] = useState(-1);

    return (
        <PageFade>
            <PageTemplate minor={true} title="Portrait Lounge Photos" textColor="text-rose" bgColor="bg-white">
                <WideContent>
                    <div className="max-w-4xl mx-auto text-center space-y-4">
                        <p className="mb-10 px-4">
                            Thank you for stopping by the Portrait Lounge and making so many fun memories with us. Browse through the gallery and click your favorite photos to view and download them in full resolution.
                        </p>
                        <p>
                            <Link to="/gallery" className="text-rose hover:underline">
                                Back to Wedding Gallery
                            </Link>
                        </p>
                    </div>
                </WideContent>
                <div className="container p-8 lg:p-10 xl:p-16 text-center mx-auto" >
                    <div className="mx-auto">
                        <PhotoAlbum
                            photos={portraitsThumbnails}
                            layout="rows"
                            spacing={5}
                            onClick={({ index }) => setIndex(index)}
                        />

                        <Lightbox
                            slideshow={{ delay: 5000 }}
                            slides={portraits}
                            open={index >= 0}
                            index={index}
                            close={() => setIndex(-1)}
                            plugins={[Fullscreen, Slideshow, Download]}
                            styles={{
                                container: {
                                    backgroundColor: "rgba(0, 0, 0, 0.9)"
                                },
                            }}
                        />
                    </div>
                    <p className="mt-10">
                        <Link to="/gallery" className="text-rose hover:underline">
                            Back to Wedding Gallery
                        </Link>
                    </p>
                </div>
            </PageTemplate>
        </PageFade>
    );
}

export default PortraitLoungePhotos;
